var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgHeart(props) {
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.776.898c-2.038 0-3.837 1.04-4.91 2.622C9.793 1.937 7.993.898 5.956.898 2.669.898 0 3.602 0 6.932c0 7.355 10.866 13.966 10.866 13.966S21.73 14.287 21.73 6.932c0-3.33-2.669-6.034-5.955-6.034z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.24 1.43c3.26 5.263.258 12.17-3.348 14.131-3.98 2.167-6.703 1.149-12.34-2.091 3.213 4.313 8.313 7.416 8.313 7.416S21.731 14.275 21.731 6.92a6.042 6.042 0 00-3.49-5.49z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.776.898c-2.038 0-3.837 1.04-4.91 2.622C9.793 1.937 7.993.898 5.956.898 2.669.898 0 3.602 0 6.932c0 7.355 10.866 13.966 10.866 13.966S21.73 14.287 21.73 6.932c0-3.33-2.669-6.034-5.955-6.034z",
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.776.898c-2.038 0-3.837 1.04-4.91 2.622C9.793 1.937 7.993.898 5.956.898 2.669.898 0 3.602 0 6.932c0 7.355 10.866 13.966 10.866 13.966S21.73 14.287 21.73 6.932c0-3.33-2.669-6.034-5.955-6.034z",
    fill: "url(#".concat(_id4, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _id,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.728 16.08 -11.376) scale(17.0561 13.6204)"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "red"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#C20000"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id2,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.728 14.29 -12.698) scale(14.6847 11.7267)"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "red"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id3,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.728 16.08 -11.376) scale(17.0561 13.6204)"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id4,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.12663 -5.57013 2.77411 5.54144 13.87 12.324)"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719",
    stopOpacity: 0.25
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2719",
    stopOpacity: 0
  })))));
}
export default SvgHeart;